import React from 'react';

const ErrorDisplay = ({ error, onRetry }) => {
  return (
    <div className="fixed inset-0 bg-ui-light-background dark:bg-ui-dark-background flex items-center justify-center">
      <div className="text-center max-w-md mx-auto p-8 bg-ui-light-card dark:bg-ui-dark-card rounded-lg shadow-md border border-ui-light-border dark:border-ui-dark-border transition-colors">
        <div className="w-16 h-16 mx-auto bg-status-error-light-bg dark:bg-status-error-dark-bg rounded-full flex items-center justify-center mb-4">
          <svg className="w-8 h-8 text-status-error-light-text dark:text-status-error-dark-text" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
          </svg>
        </div>
        <h2 className="mb-4 text-lg font-medium text-ui-light-text-primary dark:text-ui-dark-text-primary">Sky Viewer Error</h2>
        <p className="text-ui-light-text-secondary dark:text-ui-dark-text-secondary mb-4">{error}</p>
        <p className="text-ui-light-text-tertiary dark:text-ui-dark-text-tertiary text-sm mb-6">
          Please check your internet connection and try refreshing the page.
        </p>
        <button 
          onClick={onRetry}
          className="px-4 py-2 text-sm font-medium text-white bg-primary-600 rounded-md hover:bg-primary-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-500 transition-colors"
        >
          Reload
        </button>
      </div>
    </div>
  );
};

export default ErrorDisplay;